export function updateCampaign(campaignId) {
  return (dispatch) => {
    dispatch({
      type: 'CAMPAIGNID_UPDATE',
      data: campaignId,
    })
  }
}
